import React, { useState, useEffect } from 'react'
import { Backdrop, CircularProgress, Typography } from '@mui/material'
import { useParams } from 'react-router-dom'
import useStyles from './useStyle'
import UsersTable from './TableNavigable/TableNavigable'

import { useDispatch } from 'react-redux'
import {
  getAllUsersOfSuborganizations,
  getSuborganizations
} from '../../../redux/actions/Suborganizations'
import BreadcrumbsComponent from './Breadcrumbs/Breadcrumbs'
import InfoIcon from '@mui/icons-material/Info'

export default function UsersOfSuborganization () {
  const { id } = useParams()
  const classes = useStyles()
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(false)
  const [suborganizationName, setSuborganizationName] = useState(null)
  const dispatch = useDispatch()

  const getUsers = async () => {
    const usersbysuborg = await dispatch(getAllUsersOfSuborganizations(id))
    setRows(usersbysuborg)
  }

  const getSuborganization = async () => {
    const response = await dispatch(getSuborganizations(id))
    if (response) setSuborganizationName(response.suborganizationName)
  }

  useEffect(async () => {
    setLoading(true)
    await getSuborganization()
    await getUsers()
    setLoading(false)
  }, [id])

  return (
    <div className={classes.root}>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <BreadcrumbsComponent name={suborganizationName} />
      <div className={classes.boxtitle}>
        <Typography className={classes.title}>
          Usuarios asociados a un Estudio
        </Typography>
      </div>
      <div className={classes.boxSubTitle}>
        <InfoIcon
          style={{ fontSize: '2rem', color: '#00a78f', marginLeft: 10 }}
        />
        <Typography className={classes.subtitle}>
          La siguiente lista muestra los usuarios del asociados al estudio{' '}
          {suborganizationName || ''}.
        </Typography>
      </div>
      <div className={classes.boxTable}>
        <UsersTable rows={rows} setLoading={setLoading} />
      </div>
    </div>
  )
}
